module.exports = __webpack_public_path__ + "img/googleplay.f3bc9717.png";